import { render, staticRenderFns } from "./changeRecord.vue?vue&type=template&id=1bb450b7&scoped=true"
import script from "./changeRecord.vue?vue&type=script&lang=js"
export * from "./changeRecord.vue?vue&type=script&lang=js"
import style0 from "./changeRecord.vue?vue&type=style&index=0&id=1bb450b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb450b7",
  null
  
)

export default component.exports